import React, { useContext } from 'react'
import TimelineSidebarLayout from '../../../../Shared/TimelineSidebar'
import ProjectAssets from './TimelineSidebarParts/ProjectAssets'
import ScenarioAssets from './TimelineSidebarParts/ScenarioAssets'
import { TimelineContext } from '../../../../../contexts/TimelineContext'
import TimelineNotesSection from '../../../../Shared/TimelineNotesSection'

export default function TimelineSidebar({
  activeTab = 'timeline',
}) {
  const { layout } = useContext(TimelineContext)

  return (
    <TimelineSidebarLayout
      shellClassName={layout === 'embedded' ? 'min-h-0 shrink-0 self-stretch' : ''}
    >
      {activeTab === 'notes' ? (
        <TimelineNotesSection />
      ) : (
        <>
          <ProjectAssets />
          <ScenarioAssets />
        </>
      )}
    </TimelineSidebarLayout>
  )
}
